import React from 'react'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import shortid from 'shortid'
import get from 'lodash/get'
import * as CONSTANTS from '../../constants'
import left_arrow from '../../../../static/images/left-arrow.svg'
import { FONTS } from '../../../../constants'

export default class ExpenditureSummaryTable extends React.Component {
  state={ collapse_overall: false }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)
    && JSON.stringify(nextState) === JSON.stringify(this.state)) return false
    return true
  }

  render() {
    const activeToggle = get(this.props, 'activeToggle')
    const projectByID = get(this.props, 'projectByID')
    const projectType = get(projectByID, 'project_type')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot') || false
    const rSelected = get(this.props, 'rSelected')
    // const presale_snapshot = get(this.props, 'presale_snapshot')
    const isPresale = presale_snapshot && rSelected === 1
    // employee
    const employee_man_days = isPresale ? presale_snapshot.$total_employee_man_days : get(projectByID, '$total_employee_man_days', '-')
    const employee_cost = isPresale ? presale_snapshot.$total_employee_cost : get(projectByID, '$total_employee_cost', '-')
    const employee_man_days_percentage = isPresale ? presale_snapshot.$employee_man_days_percentage : get(projectByID, '$employee_man_days_percentage', '-')
    const employee_man_days_avg = isPresale ? presale_snapshot.$total_employee_man_days_avg : get(projectByID, '$total_employee_man_days_avg', '-')
    
    const standard_total_employee_cost = isPresale ? presale_snapshot.$standard_total_employee_cost : get(projectByID, '$standard_total_employee_cost', '-')
    const standard_total_employee_man_days_avg = isPresale ? presale_snapshot.$standard_total_employee_man_days_avg : get(projectByID, '$standard_total_employee_man_days_avg', '-')


    // sub-contract
    const subcontract_man_days = isPresale ? presale_snapshot.$total_subcontract_man_days : get(projectByID, '$total_subcontract_man_days', '-')
    const subcontract_cost = isPresale ? presale_snapshot.$total_subcontract_cost : get(projectByID, '$total_subcontract_cost', '-')
    const subcontract_man_days_percentage = isPresale ? presale_snapshot.$subcontract_man_days_percentage : get(projectByID, '$subcontract_man_days_percentage', '-')
    const subcontract_man_days_avg = isPresale ? presale_snapshot.$total_subcontract_man_days_avg : get(projectByID, '$total_subcontract_man_days_avg', '-')

    // vendor
    const vendors_man_days = isPresale ? presale_snapshot.$total_vendors_man_days : get(projectByID, '$total_vendors_man_days', '-')
    const vendors_cost = isPresale ? presale_snapshot.$total_vendors_cost : get(projectByID, '$total_vendors_cost', '-')
    const vendors_man_days_percentage = isPresale ? presale_snapshot.$vendors_man_days_percentage : get(projectByID, '$vendors_man_days_percentage', '-')
    const vendors_man_days_avg = isPresale ? presale_snapshot.$total_vendors_man_days_avg : get(projectByID, '$total_vendors_man_days_avg', '-')

    // License
    const licenses_cost = isPresale ? presale_snapshot.$total_licenses_cost : get(projectByID, '$total_licenses_cost', '-')

    // Hardware
    const hardwares_cost = isPresale ? presale_snapshot.$total_hardwares_cost : get(projectByID, '$total_hardwares_cost', '-')

    // Other
    const other_costs_sum = isPresale ? presale_snapshot.$total_other_costs_sum : get(projectByID, '$total_other_costs_sum', '-')

    // Total
    const service_man_days = isPresale ? presale_snapshot.$service_man_days : get(projectByID, '$service_man_days', '-')
    const sum_total_cost = isPresale ? presale_snapshot.$sum_total_cost : get(projectByID, '$sum_total_cost', '-')
    const sum_total_standard_cost = isPresale ? presale_snapshot.$sum_total_standard_cost : get(projectByID, '$sum_total_standard_cost', '-')
    const fallbackNanOrInfinity = (number) => {
      return number === 'NaN' || number === Infinity ? '0.00' : number
    }
    return (
    /* eslint no-underscore-dangle: 0 */
      <CustomTable bordered hover>
        <Header onClick={ () => this.setState({ collapse_overall: !this.state.collapse_overall }) }>
          <tr>
            <th>
              <Icon
                style={ { transform: this.state.collapse_overall ? 'rotate(180deg)' : 'rotate(270deg)' } }
                src={ left_arrow }
                collapse={ !this.state.collapse_overall }
              />
            </th>
            <th style={ { paddingLeft: 0 } }>Expenditure Summary</th>
          </tr>
        </Header>
        <SubHeader style={ { display: this.state.collapse_overall ? 'none' : '' } }>
          <tr style={ { fontFamily: 'Gotham', backgroundColor: '#FFFFFF' } }>
            {
              CONSTANTS.expenditure_summary_table_header.column.map((h) =>
                (<HeadTable key={ shortid() }>
                  { h }
                </HeadTable>)
              )}
          </tr>
        </SubHeader>
        <BodyTable style={ { display: this.state.collapse_overall ? 'none' : '' } }>
          { CONSTANTS.expenditure_summary_table_header.row.map(r => {
            if (r === 'Employee') {
              return (
                <tr key={ shortid() }>
                  <td>{ r }</td>
                  <td>{ employee_man_days }</td>
                  <td>{ fallbackNanOrInfinity(employee_man_days_percentage) } %</td>
                  <td>{ (() => {
                    if (projectType === CONSTANTS.SUPPORT) return employee_man_days_avg
                    else if (activeToggle === 1) return '-'
                    else if (activeToggle === 2) return standard_total_employee_man_days_avg
                    return employee_man_days_avg
                  })() }
                  </td>
                  <td>{ (() => {
                    if (projectType === CONSTANTS.SUPPORT) return employee_cost
                    else if (activeToggle === 1) return '-'
                    else if (activeToggle === 2) return standard_total_employee_cost
                    return employee_cost
                  })() }
                  </td>
                </tr>
              )
            }
            if (r === 'Sub-Contractor') {
              return (
                <tr key={ shortid() }>
                  <td>{ r }</td>
                  <td>{ subcontract_man_days }</td>
                  <td>{ fallbackNanOrInfinity(subcontract_man_days_percentage) } %</td>
                  <td>{ (() => {
                    if (projectType === CONSTANTS.SUPPORT) return subcontract_man_days_avg
                    else if (activeToggle === 1) return '-'
                    else if (activeToggle === 2) return subcontract_man_days_avg
                    return subcontract_man_days_avg
                  })() }
                  </td>
                  <td>{ (() => {
                    if (projectType === CONSTANTS.SUPPORT) return subcontract_cost
                    else if (activeToggle === 1) return '-'
                    else if (activeToggle === 2) return subcontract_cost
                    return subcontract_cost
                  })() }
                  </td>
                </tr>
              )
            }
            if (r === 'Other Service') {
              return (
                <tr key={ shortid() }>
                  <td>{ r }</td>
                  <td>{ vendors_man_days }</td>
                  <td>{ fallbackNanOrInfinity(vendors_man_days_percentage) } %</td>
                  <td>{ vendors_man_days_avg }</td>
                  <td>{ vendors_cost }</td>
                </tr>
              )
            }
            if (r === 'License/MA') {
              return (
                <tr key={ shortid() }>
                  <td>{ r }</td>
                  <td>{ '-' }</td>
                  <td>{ '-' }</td>
                  <td>{ '-' }</td>
                  <td>{ licenses_cost }</td>
                </tr>
              )
            }
            if (r === 'Hardware') {
              return (
                <tr key={ shortid() }>
                  <td>{ r }</td>
                  <td>{ '-' }</td>
                  <td>{ '-' }</td>
                  <td>{ '-' }</td>
                  <td>{ hardwares_cost }</td>
                </tr>
              )
            }
            if (r === 'Other') {
              return (
                <tr key={ shortid() }>
                  <td>{ r }</td>
                  <td>{ '-' }</td>
                  <td>{ '-' }</td>
                  <td>{ '-' }</td>
                  <td>{ other_costs_sum }</td>
                </tr>
              )
            }
            return null
          })
          }
        </BodyTable>
        <SubHeader style={ { display: this.state.collapse_overall ? 'none' : '' } }>
          <tr style={ { fontFamily: 'Gotham' } }>
            <HeadTable key={ shortid() } >Total</HeadTable>
            { CONSTANTS.expenditure_summary_table_header.column.map((h) => {
              if (h === 'Man-Day(s)') {
                return (
                  <HeadTable key={ shortid() } >
                    { service_man_days }
                  </HeadTable>
                )
              }
              if (h === 'Man-Day(s) Ratio') {
                return (
                  <HeadTable key={ shortid() } >
                    { service_man_days > 0 ? '100.00%' : '0.00%' }
                  </HeadTable>
                )
              }
              if (h === 'Average Man-Day Rate (฿)') {
                return (
                  <HeadTable key={ shortid() } >
                    -
                  </HeadTable>
                )
              }
              if (h === 'Cost (฿)') {
                return (
                  <HeadTable key={ shortid() }>{ (() => {
                    if (projectType === CONSTANTS.SUPPORT) return sum_total_cost
                    else if (activeToggle === 1) return '-'
                    else if (activeToggle === 2) return sum_total_standard_cost
                    return sum_total_cost
                  })() }
                  </HeadTable>
                )
              }
              return null
            }
            )}
          </tr>
        </SubHeader>
      </CustomTable>
    )
  }
}

const CustomTable = styled(Table)`
  background: white;
  margin-bottom: 0px;
  thead {
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border-bottom: 1px solid #CCCCCC !important;
  } tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-weight: lighter !important;
    font-size: ${FONTS.SMALL_SIZE};
  } tbody td {
    font-family: 'NotoSans' !important;
    font-variant-numeric: tabular-nums;
    -moz-font-feature-settings: "tnum";
    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum";
    border: none ;
    text-align:right;
    justify-content: flex-end;
  } thead th {
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border: none ;
    text-align:right;
    justify-content: flex-end;
  }
`
const BodyTable = styled.tbody`
  width: 100% ;
  display: block ;
  max-height: calc(100vh - 225px);
  overflow-y:scroll;
  border: none ;
  background-color: #F9F9F9;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: black;
  font-family: 'NotoSans' !important;
  font-variant-numeric: tabular-nums;
  -moz-font-feature-settings: "tnum";
  -webkit-font-feature-settings: "tnum";
  font-feature-settings: "tnum";
  font-weight: 900;
  font-size: 14px ;
`
const Icon = styled.img`
  width : 10px ;
  height : 10px;
  margin-left: 1%;
  margin-right: 1%;
  cursor: pointer;
`
const SubHeader = styled.thead`
  background-color: #F9F9F9;
  border-bottom: 1px solid #CCCCCC !important;
  color: black;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
`
const Header = styled.thead`
  height: 50px;
  background: #404040;
  color: white;
  display: flex !important;
  align-items: center;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-overview/table-expenditure-summary.js